// Copyright (c) 2017 PlanGrid, Inc.

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PhotoViewer extends Component {
  componentDidMount() {
    const { originalWidth, originalHeight } = this.props;
    const imageDimensions = this.getImageDimensions.call(this, originalWidth, originalHeight);
    this.props.texture.style.width = `${imageDimensions.width}px`;
    this.props.texture.style.height = `${imageDimensions.height}px`;
    this.props.texture.setAttribute('class', 'photo');
    document.getElementById('pg-photo-container').appendChild(this.props.texture);
  }

  getImageDimensions(originalWidth, originalHeight) {
    // Scale image to fit into viewer
    let imgHeight;
    let imgWidth;
    const { height, width } = this.props;
    if (originalHeight <= height && originalWidth <= width) {
      imgWidth = originalWidth;
      imgHeight = originalHeight;
    } else {
      const heightRatio = height / originalHeight;
      const widthRatio = width / originalWidth;
      if (heightRatio < widthRatio) {
        imgHeight = originalHeight * heightRatio;
        imgWidth = originalWidth * heightRatio;
      } else {
        imgHeight = originalHeight * widthRatio;
        imgWidth = originalWidth * widthRatio;
      }
    }
    return { height: imgHeight, width: imgWidth };
  }

  render() {
    const containerStyles = {
      width: `${this.props.texture.style.width}px`,
      height: `${this.props.texture.style.height}px`,
    };
    return (
      <div style={containerStyles} className="d-flex flex-row h-100 w-100 align-items-center justify-content-center" id="pg-photo-container" />
    );
  }
}

PhotoViewer.propTypes = {
  originalWidth: PropTypes.number.isRequired,
  originalHeight: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  texture: PropTypes.shape({
    style: PropTypes.shape({
      width: PropTypes.string.isRequired,
      height: PropTypes.string.isRequired,
    }),
    setAttribute: PropTypes.func.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/FileViewer/drivers/photo-viewer.jsx